import './TestScreen.scss';
import MedicalHistoryQuestionnairePdf from "../pdf/medical-history-questionnaire/MedicalHistoryQuestionnairePdf";


// Create styles

const TestScreen = () => {

    // const data = {
    //         "2025-03-10": 0,
    //         "2025-03-11": 0,
    //         "2025-03-12": 0,
    //         "2025-03-13": 0,
    //         "2025-03-14": 0,
    //         "2025-03-15": 1,
    //         "2025-03-16": 0,
    //         "2025-03-17": 1
    // }
    return (
        <div >
            <div>Test screen</div>
                <MedicalHistoryQuestionnairePdf/>


{/*            <PDFDownloadLink document={*/}
{/*                <Document style={{padding: '24px'}}>*/}
{/*                    <Page size="A4" style={{padding: '24px'}}>*/}
{/*                        <View style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>*/}
{/*                            <View>*/}
{/*                                <Text>Subsection #1</Text>*/}
{/*                            </View>*/}
{/*                            <View>*/}
{/*                                <Text>Subsection #2</Text>*/}
{/*                            </View>*/}
{/*                            /!*<View>*!/*/}
{/*                            /!*    <Text>Section #2</Text>*!/*/}
{/*                            /!*</View>*!/*/}
{/*                        </View>*/}
{/*                        <View>*/}
{/*                            <Table style={{borderRadius:'8px'}} >*/}
{/*                                <TH>*/}
{/*                                    <TD style={{padding:'10px'}}>Header 1</TD>*/}
{/*                                    <TD style={{padding:'10px'}}>Header 2</TD>*/}
{/*                                    <TD  style={{padding:'10px'}}>Header 3</TD>*/}
{/*                                </TH>*/}
{/*                                <TR>*/}
{/*                                    <TD style={styles.row}>Data 1</TD>*/}
{/*                                    <TD  style={styles.row}>Data 2</TD>*/}
{/*                                    <TD  style={styles.row}>Data 3</TD>*/}
{/*                                </TR>*/}
{/*                            </Table>*/}
{/*                        </View>*/}
{/*                    </Page>*/}
{/*                </Document>*/}
{/*}>*/}
{/*                <ButtonComponent>*/}
{/*                    Click to download PDF*/}
{/*                </ButtonComponent>*/}
{/*            </PDFDownloadLink>*/}

            {/*<ProgressBarComponent progress={100}/>*/}
            {/*<AlertCardComponent message={'Testing the alert card'} className={'warning'} action={<LinkComponent>Know More</LinkComponent>}/>*/}
            {/*<DateRangePickerComponentV2/>*/}
        </div>

    )
};
export default TestScreen;
